export const WEB_CHAT_SET_SEND_BOX_ATTACHMENTS = 'WEB_CHAT/SET_SEND_BOX_ATTACHMENTS'
export const DIRECT_LINE_POST_ACTIVITY = 'DIRECT_LINE/POST_ACTIVITY'
export const DIRECT_LINE_POST_ACTIVITY_FULFILLED = 'DIRECT_LINE/POST_ACTIVITY_FULFILLED'
export const DIRECT_LINE_INCOMING_ACTIVITY = 'DIRECT_LINE/INCOMING_ACTIVITY'
export const LANGUAGE_CHANGED = 'custom/languageChanged'
export const SEND_USER_LOCATION = 'custom/send_user_location'
export const WEBCHAT_UPLOAD = 'webchat/upload'
export const WEBCHAT_SET_SUGGESTED_ACTIONS = 'WEB_CHAT/SET_SUGGESTED_ACTIONS'
export const WEBCHAT_SUBMIT_SEND_BOX = 'WEB_CHAT/SUBMIT_SEND_BOX'
export const WEB_CHAT_SEND_TYPING = 'WEB_CHAT/SEND_TYPING'
